import { Component, OnInit, Input } from '@angular/core';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME, ProspectState } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { PageIndividualOnExchangePlanEnrollmentService } from '../services/page-individual-on-exchange-plan-enrollment.service';
import { EnrollManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/enroll-manager.service';
import { OnExchangeEnrollmentNormalizedResponse, OnExchangeEnrollResponse } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-enrollment.response-payload.interface';
import { IndividualMarketsEnrollmentSubmissionService } from 'src/app/angular-elements/shared/services/enrollment/individual-markets/enrollment-submission.individual-markets.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PtlWindowLocationService } from '@ptl/global-components';

/** Uses PLAN-ENROLLMENT.COMPONENT.TS to display */

@FormComponentLookup('page-individual-on-exchange-plan-enrollment')
@Component({
    selector: 'app-page-individual-on-exchange-plan-enrollment',
    templateUrl: './page-individual-on-exchange-plan-enrollment.component.html',
    styleUrls: ['./page-individual-on-exchange-plan-enrollment.component.scss'],
    standalone: false
})
export class PageIndividualOnExchangePlanEnrollmentComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  @Input() formConfigStrategy: string;

  notActiveSubmission = true; // set false when running submission XHR, drives loading indicator display
  disableSubmit = false;

  exactTargetTemplate = {
    WPA: 'OffExchangeAppConfirmationWPA',
    CPA: 'OffExchangeAppConfirmationCPA',
    NEPA: 'OffExchangeAppConfirmationNEPA',
    DE: 'OffExchangeAppConfirmationDE',
    WV: 'OffExchangeAppConfirmationWV',
    ND: 'HCREnrollmentsConfirmND',
    WY: 'HCREnrollmentsConfirmWY',
    MINCR: 'null'
  };
  prospect: ProspectState = null;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private enrollmentSubmitIndividual: IndividualMarketsEnrollmentSubmissionService,
    private eligibilityManagerService: EligibilityManagerService,
    private enrollManagerService: EnrollManagerService,
    private pageIndividualOnExchangePlanEnrollmentService: PageIndividualOnExchangePlanEnrollmentService,
    private windowLocationService: PtlWindowLocationService
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[
      ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME
      ];
    const matchedProspects = eligibilityState.prospects.filter(p => eligibilityState.currentProspectId === p.prospectId);

    if (matchedProspects.length > 0) {
      this.prospect = matchedProspects[0];
      const storageData = this.eligibilityManagerService.get(this.prospect.prospectId);
    }

    this.initPageConfig();
  }

  nextHook(formConfig): Promise<any> {

    return new Promise((resolve, reject) => {
      this.formPageActions.nextHook(formConfig);
      resolve(resolve);
    });

  }

  submitButton(): void {
    const validation = this.validateFormGroups(this.pageFormGroups);
    if (validation) {
      super.submitButton();
    }
  }

  /**
   * Errors of sub-forms are stored in a service related to this whole page/form
   */
  validateFormGroups(formGroups: {}) {
    if (this.pageIndividualOnExchangePlanEnrollmentService.hasErrors()) {
      return false;
    }
    return true;
  }

  submitHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {

      this.notActiveSubmission = false;
      this.disableSubmit = true;

      const response: OnExchangeEnrollmentNormalizedResponse<OnExchangeEnrollResponse>
        = await this.enrollmentSubmitIndividual.setOnExchangeEnrollmentPayLoad();

      if (response) {
        const data: OnExchangeEnrollResponse = response.payload;

        this.enrollManagerService.setPaymentTransactionId(data);
        this.enrollManagerService.setFFMPolicyNumber(data);
        this.enrollManagerService.setAppStatus(response.appStatus);

        await this.enrollManagerService.emailConfirmation({
          overrideTemplate: this.exactTargetTemplate[this.enrollManagerService.getRegion()],
          exchangeType: 'ONX', TOEMAIL: this.prospect.data.customerData.emailAddress
        });

        // Handle response.
        if (!(response instanceof HttpErrorResponse)) {
          this.windowLocationService.goToUrl(this.formConfig.form.customConfigs.confirmationPageUrl);
        } else {
          this.notActiveSubmission = true;
          this.disableSubmit = false;
          return null;
        }

        resolve(true);
      } else {
        this.notActiveSubmission = true;
        this.disableSubmit = false;
        reject();
      }

    });
  }

}
